import { AxiosError } from 'axios'
import { ApiService } from './constant.services'
import { kyc } from '@models'

export const kycServices = async () => {
    try {
        const response = await ApiService.get<kyc>(`user/verificate/kyc`)

        return response.data
    } catch (error) {
        const err = error as AxiosError

        console.log(err.response?.data)

        return err.response?.data
    }
}
